// extracted by mini-css-extract-plugin
module.exports = {"container":"ForgotPasswordConfirm_container__X80Op","btnBox":"ForgotPasswordConfirm_btnBox__SqOt7","textConfirm":"ForgotPasswordConfirm_textConfirm__3LOM7"};